import { Environments } from '@/config';
import { HEALTH_PARTNERS_PRODUCTION } from './health-partners.production';
import { HEALTH_PARTNERS_STAGING } from './health-partners.staging';

export const HEALTH_PARTNERS =
  import.meta.env.MODE === Environments.PROD ? HEALTH_PARTNERS_PRODUCTION : HEALTH_PARTNERS_STAGING;
